import { render, staticRenderFns } from "./Selected.vue?vue&type=template&id=1b367c83&scoped=true&"
import script from "./Selected.vue?vue&type=script&lang=js&"
export * from "./Selected.vue?vue&type=script&lang=js&"
import style0 from "./Selected.vue?vue&type=style&index=0&id=1b367c83&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b367c83",
  null
  
)

export default component.exports